<template>
  <v-card class="forgot-pwd-com mx-auto pa-3 mt-5" max-width="430">
    <v-card-text>
      <div class="forgot-pwd-content">
        <div class="d-flex justify-space-between" style="margin-bottom: 10px;">
          <p class="card-title">{{ $t('login.forgotPwd') }}</p>
          <div class="close-btn" @click="navigatePush('home')">&times;</div>
        </div>

        <!-- Email field -->
        <ValidationObserver ref="observer" v-slot="{ invalid, passes }">
          <ValidationProvider ref="email" :name="$t('labels.email')" rules="required|email" v-slot="{ errors }">
            <v-text-field
              v-model.trim="form_email.email"
              :label="$t('labels.email')"
              dense
              outlined
              single-line
              clearable
              :error-messages="errors[0]"
              tabindex="1"
            >
            </v-text-field>
          </ValidationProvider>

          <!-- Email OTP Field -->
          <div class="code-btn-container d-flex">
            <ValidationProvider
              :name="$t('labels.emailOtp')"
              rules="required|numeric|length:6"
              v-slot="{ errors }"
              style="width:100%"
            >
              <v-text-field
                v-model.trim="form_email.validateCode"
                @keyup.enter="geetestVerify"
                :label="$t('labels.emailOtp')"
                dense
                outlined
                single-line
                :error-messages="errors[0]"
                @keypress="isNumeric()"
                tabindex="2"
              ></v-text-field>
            </ValidationProvider>

            <VerifyBtn
              type="forgot-pwd"
              :value="form_email.email"
              :geetest="true"
              :onProgressText="$t('common.verifyCount')"
              :condition="getVerifyCodeByEmailCondition"
            ></VerifyBtn>
          </div>

          <!-- Password Field -->
          <ValidationProvider :name="$t('labels.pwd')" rules="required|pwdRule" vid="pwd" v-slot="{ errors }">
            <v-text-field
              v-model.trim="form_email.password"
              :label="$t('labels.acc.loginPwd.newPwd')"
              id="password"
              dense
              outlined
              clearable
              single-line
              :error-messages="errors[0]"
              :type="showPassword ? 'text' : 'password'"
              :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
              @click:append="showPassword = !showPassword"
              tabindex="3"
            >
            </v-text-field>
          </ValidationProvider>

          <!-- Confirm Password Field  -->
          <ValidationProvider :name="$t('labels.confirmPwd')" rules="required|confirmed:pwd" v-slot="{ errors }">
            <v-text-field
              v-model.trim="form_email.repwd"
              :label="$t('labels.confirmPwd')"
              id="confirmPassword"
              dense
              outlined
              clearable
              single-line
              :error-messages="errors[0]"
              :type="showConfirmedPwd ? 'text' : 'password'"
              :append-icon="showConfirmedPwd ? 'mdi-eye' : 'mdi-eye-off'"
              @click:append="showConfirmedPwd = !showConfirmedPwd"
              tabindex="4"
            ></v-text-field>
          </ValidationProvider>

          <div class="submit-container">
            <v-btn
              class="btn-common"
              ref="submitBtn"
              :loading="form_email_loading"
              @click="passes(findPwdByEmail)"
              depressed
              tabindex="5"
              >{{ $t('labels.reset') }}</v-btn
            >
          </div>
        </ValidationObserver>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
import index from './forget-pwd';
export default index;
</script>

<style lang="stylus" scoped>
@import "../common.styl"

.code-btn-container {
  position: relative;

  .v-input{
     >>> .v-text-field__slot{
      padding-right: 65px;
    }
  }
}

.verify-btn {
  font-size: 12px;
  position: absolute;
  top: 8px;
  right: 10px;
  padding: 5px 0;
  border: none;
  height: initial;
  line-height: initial;
  background-color: transparent;
}

.register-btn {
  font-size: 14px;
  letter-spacing: 0px;
  height: 40px;
  margin: 10px 0;
  border-radius: 3px;
  background-color: #7b9af4 !important;
}

.opacity-btn{
  opacity : 0.6;
}
</style>
